import {
  getCategories,
  getEntitlementByID,
  IEntitlement,
} from 'API/compassRights';
import { CustomMetaTitle } from 'Components/CustomMetaTitle';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useIsDesktop } from 'Hooks';
import { CompassRightsMobileBackground } from 'Images';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { EntitlementCategories } from './EntitlementCategories';
import { EntitlementData } from './EntitlementData';
import { useLoader } from 'Hooks/useLoader';
import { CompassHeader } from 'Modules/CompassRights/CompassRightsContextWrapper/CompassHeader';
import { LinkArrowLeft2 } from 'Components';
import { Avatar, Stack } from '@mui/material';

export const CompassRightsEntitlement = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const { pathname } = useLocation();
  const [entitlement, setEntitlement] = useState<{
    userEntitlement: IEntitlement;
    lastUpdateDate: Date;
  } | null>(null);
  const [categories, setCategories] = useState([]);
  const { isLoading, setIsLoading, loader } = useLoader();
  const isDesktop = useIsDesktop();

  const initCompassRightsEntitlement = useCallback(async () => {
    const entitlementID = pathname.split('/')[pathname.split('/').length - 1];
    setIsLoading(true);
    const [entitlementResult, categoriesResult] = await Promise.all([
      getEntitlementByID(entitlementID),
      getCategories(),
    ]);
    setEntitlement(entitlementResult ?? null);
    setCategories(categoriesResult ?? null);
    setIsLoading(false);
  }, [pathname, setIsLoading]);

  useEffect(() => {
    initCompassRightsEntitlement();
    window.scrollTo(0, 0);
  }, [initCompassRightsEntitlement, imposterId]);

  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.CompassRights].title} />
      {isLoading
        ? loader
        : entitlement && (
            <Stack gap={isDesktop ? '54px' : '32px'}>
              <LinkArrowLeft2
                text={
                  Dictionary[DICTIONARY.CompassRights].entitlements.lastPage
                }
                href='/compass-rights'
                newWindow={false}
                sx={{ flexDirection: 'row-reverse' }}
                imgSx={{ transform: 'rotate(0)' }}
              />
              {!isDesktop && (
                <Avatar
                  src={CompassRightsMobileBackground}
                  alt={''}
                  sx={{
                    width: 'auto',
                    height: 'auto',
                    position: 'absolute',
                    top: '16px',
                    left: 0,
                    right: 0,
                    zIndex: -1,
                  }}
                />
              )}
              <Stack maxWidth={isDesktop ? '1029px' : 'initial'} gap={'40px'}>
                <CompassHeader
                  lastUpdateDate={entitlement?.lastUpdateDate}
                  title={entitlement?.userEntitlement?.name}
                />

                <Stack>
                  <EntitlementCategories
                    allCategories={categories}
                    categories={{
                      category: entitlement?.userEntitlement.category,
                      subCategory: entitlement?.userEntitlement.subCategory,
                    }}
                    automatic={entitlement?.userEntitlement.automatic}
                    oneTime={entitlement?.userEntitlement.oneTime}
                  />
                  <EntitlementData
                    userEntitlement={entitlement?.userEntitlement}
                  />
                </Stack>
              </Stack>
            </Stack>
          )}
    </>
  );
};
